/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreeNightCredit
 */
export interface FreeNightCredit {
    /**
     * 
     * @type {string}
     * @memberof FreeNightCredit
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FreeNightCredit
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof FreeNightCredit
     */
    loyaltyAccountId?: string | null;
    /**
     * e.g. Marriott Bonvoy, World of Hyatt
     * @type {string}
     * @memberof FreeNightCredit
     */
    programName: string;
    /**
     * 
     * @type {string}
     * @memberof FreeNightCredit
     */
    creditType: FreeNightCreditCreditTypeEnum;
    /**
     * Total credits earned this period
     * @type {number}
     * @memberof FreeNightCredit
     */
    totalCount: number;
    /**
     * Credits not yet redeemed
     * @type {number}
     * @memberof FreeNightCredit
     */
    remainingCount: number;
    /**
     * 
     * @type {Date}
     * @memberof FreeNightCredit
     */
    earnedDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof FreeNightCredit
     */
    expirationDate: Date;
    /**
     * 
     * @type {number}
     * @memberof FreeNightCredit
     */
    earningYear: number;
    /**
     * Max standard-rate points/night the credit covers (Marriott/IHG/Wyndham). Null = no cap (Hilton).
     * @type {number}
     * @memberof FreeNightCredit
     */
    pointsCap?: number | null;
    /**
     * Max hotel category the credit covers (Hyatt). Null for non-category programs.
     * @type {number}
     * @memberof FreeNightCredit
     */
    categoryCap?: number | null;
    /**
     * Whether the program allows topping up cash/points above points_cap.
     * @type {boolean}
     * @memberof FreeNightCredit
     */
    topUpAllowed: boolean;
    /**
     * Whether expiration reminders fire for this credit (GON-5964). Defaults true.
     * @type {boolean}
     * @memberof FreeNightCredit
     */
    remindersEnabled: boolean;
    /**
     * How this credit was created
     * @type {string}
     * @memberof FreeNightCredit
     */
    source?: FreeNightCreditSourceEnum;
    /**
     * User-provided notes (manual credits only)
     * @type {string}
     * @memberof FreeNightCredit
     */
    notes?: string | null;
    /**
     * Program-specific details
     * @type {object}
     * @memberof FreeNightCredit
     */
    creditMetadata?: object;
}


/**
 * @export
 */
export const FreeNightCreditCreditTypeEnum = {
    MarriottFreeNight: 'marriott_free_night',
    HiltonFreeNight: 'hilton_free_night',
    HyattFreeNight: 'hyatt_free_night',
    IhgFreeNight: 'ihg_free_night',
    WyndhamFreeNight: 'wyndham_free_night'
} as const;
export type FreeNightCreditCreditTypeEnum = typeof FreeNightCreditCreditTypeEnum[keyof typeof FreeNightCreditCreditTypeEnum];

/**
 * @export
 */
export const FreeNightCreditSourceEnum = {
    EmailParser: 'email_parser',
    ManualEntry: 'manual_entry'
} as const;
export type FreeNightCreditSourceEnum = typeof FreeNightCreditSourceEnum[keyof typeof FreeNightCreditSourceEnum];


/**
 * Check if a given object implements the FreeNightCredit interface.
 */
export function instanceOfFreeNightCredit(value: object): value is FreeNightCredit {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('programName' in value) || value['programName'] === undefined) return false;
    if (!('creditType' in value) || value['creditType'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('remainingCount' in value) || value['remainingCount'] === undefined) return false;
    if (!('earnedDate' in value) || value['earnedDate'] === undefined) return false;
    if (!('expirationDate' in value) || value['expirationDate'] === undefined) return false;
    if (!('earningYear' in value) || value['earningYear'] === undefined) return false;
    if (!('topUpAllowed' in value) || value['topUpAllowed'] === undefined) return false;
    if (!('remindersEnabled' in value) || value['remindersEnabled'] === undefined) return false;
    return true;
}

export function FreeNightCreditFromJSON(json: any): FreeNightCredit {
    return FreeNightCreditFromJSONTyped(json, false);
}

export function FreeNightCreditFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreeNightCredit {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['user_id'],
        'loyaltyAccountId': json['loyalty_account_id'] == null ? undefined : json['loyalty_account_id'],
        'programName': json['program_name'],
        'creditType': json['credit_type'],
        'totalCount': json['total_count'],
        'remainingCount': json['remaining_count'],
        'earnedDate': (new Date(json['earned_date'])),
        'expirationDate': (new Date(json['expiration_date'])),
        'earningYear': json['earning_year'],
        'pointsCap': json['points_cap'] == null ? undefined : json['points_cap'],
        'categoryCap': json['category_cap'] == null ? undefined : json['category_cap'],
        'topUpAllowed': json['top_up_allowed'],
        'remindersEnabled': json['reminders_enabled'],
        'source': json['source'] == null ? undefined : json['source'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'creditMetadata': json['credit_metadata'] == null ? undefined : json['credit_metadata'],
    };
}

export function FreeNightCreditToJSON(json: any): FreeNightCredit {
    return FreeNightCreditToJSONTyped(json, false);
}

export function FreeNightCreditToJSONTyped(value?: FreeNightCredit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user_id': value['userId'],
        'loyalty_account_id': value['loyaltyAccountId'],
        'program_name': value['programName'],
        'credit_type': value['creditType'],
        'total_count': value['totalCount'],
        'remaining_count': value['remainingCount'],
        'earned_date': value['earnedDate'].toISOString().substring(0,10),
        'expiration_date': value['expirationDate'].toISOString().substring(0,10),
        'earning_year': value['earningYear'],
        'points_cap': value['pointsCap'],
        'category_cap': value['categoryCap'],
        'top_up_allowed': value['topUpAllowed'],
        'reminders_enabled': value['remindersEnabled'],
        'source': value['source'],
        'notes': value['notes'],
        'credit_metadata': value['creditMetadata'],
    };
}

